<template>
  <component
    :is="config.component"
    v-bind="config.props"
    v-on="config.on || {}"
  >
    <!-- 渲染函式優先 -->
    <template v-if="config.render">
      {{ config.render() }}
    </template>

    <!-- 處理 slots - 支援遞迴和陣列 -->
    <template v-for="(slot, slotName) in config.slots || {}">
      <!-- 物件型 slot -->
      <BobFormRenderer
        v-if="isSlotObject(slot)"
        :slot="slotName"
        :key="slotName"
        :config="slot"
      />

      <!-- 陣列型 slot -->
      <template v-else-if="Array.isArray(slot)">
        <BobFormRenderer
          v-for="(child, childIndex) in slot"
          :slot="slotName"
          :key="`${slotName}-${childIndex}`"
          :config="child"
        />
      </template>
    </template>

    <!-- 處理 childs (向後相容) -->
    <template v-if="config.childs && config.childs.length > 0">
      <BobFormRenderer
        v-for="(child, index) in config.childs"
        :key="`child-${index}`"
        :config="child"
      />
    </template>
  </component>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BobFormRenderer',
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  setup () {
    // 判斷是否為有效的 slot 物件
    const isSlotObject = (slot) => {
      return slot && typeof slot === 'object' && !Array.isArray(slot) && slot.component
    }

    return {
      isSlotObject,
    }
  },
})
</script>

<style lang="postcss" scoped>
/* 繼承父組件的樣式 */
</style>
